import { CustomMapPage, CustomMapPageProps } from 'pages/custom/shared/CustomMapPage';
import { useRef } from 'react';
import { MapRef } from 'react-map-gl';

export const Terrain3dMapWrapper = (props: CustomMapPageProps): JSX.Element => {
    const ref = useRef<MapRef>(null);

    return (
        <CustomMapPage
            {...props}
            onMapLoaded={(mapRef) => {
                const map = mapRef.getMap();

                ref.current = mapRef;

                const source = map.getSource('mapbox-dem');
                if (!source) {
                    map.addSource('mapbox-dem', {
                        type: 'raster-dem',
                        url: 'mapbox://mapbox.mapbox-terrain-dem-v1',
                        tileSize: 512,
                        maxzoom: 14
                    });
                }

                ref.current.getMap().setTerrain({ source: 'mapbox-dem', exaggeration: 2 });

                props.onMapLoaded?.(mapRef);
            }}
        />
    );
};
